// extracted by css-extract-rspack-plugin
export default {"root":"root-e4JC4v","hover":"hover-oZd0LF","pressed":"pressed-FdUtU1","focusVisible":"focusVisible-y12ITs","hidden":"hidden-dqra3w"};